// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tKl6","buttons":"styles_buttons__3HaKh"};